import React, { Component } from 'react'

class Ischedule extends Component {
  render() {
    return (
      <div>
        
      </div>
    )
  }
}


export default Ischedule;